import React from "react";
import Modal from "../../UI/Modal";
import type { OptionDto } from "../../../../domain/types/company/company-product-system";
import { isBookProductType } from "../../../../domain/types/company/company-product-system";
import {
  getAvailableTemplates,
  type PredefinedOptionTemplate,
} from "./option-constants";

interface Props {
  productType: string;
  existingOptions: OptionDto[];
  onAddPredefined: (template: PredefinedOptionTemplate) => Promise<void>;
  onOpenCustom: () => void;
  onClose: () => void;
}

export const OptionSelectModal: React.FC<Props> = ({
  productType,
  existingOptions,
  onAddPredefined,
  onOpenCustom,
  onClose,
}) => {
  const isBook = isBookProductType(productType);
  const available = getAvailableTemplates(productType, existingOptions, isBook);

  const [loading, setLoading] = React.useState(false);

  const handleClick = async (tmpl: PredefinedOptionTemplate) => {
    setLoading(true);
    try {
      await onAddPredefined(tmpl);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal setIsModalVisible={() => onClose()} title="" >
      <div className="w-[70vw] max-w-[480px] text-center py-2">
        <h2 className="text-[18px] font-bold text-[#222] mb-2">
          어떤 옵션을 추가하시겠어요?
        </h2>
        <p className="text-[13px] text-[#888] mb-6">
          고객이 주문 시 선택할 수 있는 항목을 추가합니다
        </p>

        {available.length > 0 && (
          <div className="flex justify-center gap-5 mb-7">
            {available.map((tmpl) => (
              <button
                key={tmpl.key}
                onClick={() => handleClick(tmpl)}
                disabled={loading}
                className="flex flex-col items-center gap-2.5 group disabled:opacity-50"
              >
                <div className="w-[100px] h-[100px] bg-[#f0f0f0] rounded-[16px] group-hover:bg-[#E8EFFF] transition-colors flex items-center justify-center">
                  <span className="text-[24px]">
                    {tmpl.key === "insert_paper" ? "📄" : tmpl.key === "end_paper" ? "📑" : "✨"}
                  </span>
                </div>
                <span className="text-[13px] font-medium text-[#333]">
                  {tmpl.name}
                </span>
              </button>
            ))}
          </div>
        )}

        <p className="text-[13px] text-[#999] mb-3">
          코팅, 박, 형압 등 다른 옵션을 추가하고 싶으신가요?
        </p>
        <button
          onClick={onOpenCustom}
          className="w-full max-w-[300px] h-[44px] bg-[#222] text-white text-[14px] font-medium rounded-[10px] hover:bg-[#333] transition-colors"
        >
          새 옵션 만들기
        </button>
      </div>
    </Modal>
  );
};
